module.exports = __webpack_public_path__ + "img/lb1.70aecd15.png";